module.exports = __webpack_public_path__ + "images/logo-env_development.svg?0c3f72d2e65d5b1578e8e95219a3e172";